import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowLeft, ShieldCheck, Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";
import { legalDoc } from "@/lib/legalContent";

export const LegalDocument = ({ doc }) => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const content = legalDoc(i18n.language, doc);
  return <div className="min-h-screen bg-background" data-testid={`legal-${doc}`}>
    <div className="border-b border-border bg-card/50 backdrop-blur-sm sticky top-0 z-10">
      <div className="max-w-2xl mx-auto px-4 py-4 flex items-center gap-2">
        <Sparkles className="w-5 h-5 text-primary shrink-0" />
        <span className="font-bold text-primary tracking-wide">{t("common.appName")}</span>
      </div>
    </div>
    <div className="max-w-2xl mx-auto px-4 py-8 space-y-6">
      <div className="flex items-start gap-3">
        <ShieldCheck className="w-6 h-6 text-primary shrink-0 mt-1" />
        <div>
          <h1 className="text-2xl font-bold text-foreground">{content.title}</h1>
          <p className="text-xs text-muted-foreground mt-1">{content.updated}</p>
        </div>
      </div>
      {content.sections.map(([heading, paragraphs]) => <section key={heading} className="space-y-2">
        <h2 className="text-base md:text-lg font-semibold text-primary">{heading}</h2>
        <ul className="space-y-2">
          {paragraphs.map((paragraph) => <li key={paragraph} className="text-sm text-foreground/85 leading-relaxed break-words [overflow-wrap:anywhere] flex gap-2">
            <span className="text-primary/60 shrink-0">•</span><span>{paragraph}</span>
          </li>)}
        </ul>
      </section>)}
      <Button onClick={() => navigate(-1)} variant="outline" className="w-full h-12" data-testid={`legal-${doc}-back`}>
        <ArrowLeft className="w-4 h-4 mr-2" />{t("common.back")}
      </Button>
    </div>
  </div>;
};
